import { render, staticRenderFns } from "./AddPriceBand.vue?vue&type=template&id=8b2c0558&scoped=true&"
import script from "./AddPriceBand.vue?vue&type=script&lang=js&"
export * from "./AddPriceBand.vue?vue&type=script&lang=js&"
import style0 from "./AddPriceBand.vue?vue&type=style&index=0&id=8b2c0558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c0558",
  null
  
)

export default component.exports